import {
  get,
  post,
  patch,
  del,
} from '@/utils/request';

const url = 'invoices';

export function index(data) {
  return get({
    url,
    data,
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

export function restore(id) {
  return post({
    url: `${url}/${id}`,
  });
}

export function examine(id, data) {
  return patch({
    url: `${url}/${id}/examined`,
    data,
  });
}

export function revoke(id, data) {
  return patch({
    url: `${url}/${id}/revoked`,
    data,
  });
}

export function destroy(id) {
  return del({
    url: `${url}/${id}`,
  });
}
